import React from 'react';
import styled from 'styled-components';
import {string} from 'prop-types';
import {getSrcSets} from 'app/components/helpers/helpers';

const Picture = styled.picture`
  display: flex;
  height: inherit;
  width: inherit;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
`;

const InfoCardImage = ({altText, basicName, basicRoute}) => {
  const widths = ['960', '1200', '1500'];

  const {webpSrcSet, jpgSrcSet} = getSrcSets(widths, basicRoute, basicName);
  const webpSource = <source srcSet={webpSrcSet} type='image/webp' sizes='(min-width: 492px) 492px, 100vw' />;
  const jpgSource = <source srcSet={jpgSrcSet} sizes='(min-width: 492px) 492px, 100vw' />;
  const fallbackSrc = basicRoute + basicName + '_w' + widths[0] + '.jpg';

  return (
    <Picture>
      {webpSource}
      {jpgSource}
      <Img src={fallbackSrc} alt={altText} />
    </Picture>
  );
};

InfoCardImage.propTypes = {
  altText: string,
  basicName: string.isRequired,
  basicRoute: string,
};

InfoCardImage.defaultProps = {
  altText: '',
  basicRoute: '',
};

export {InfoCardImage};
